import { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import MuiTab from '@mui/material/Tab';
import { tabRootStyles } from './tabs.styles';
import type { TabProps } from './tabs.types';

const TabButton = forwardRef<HTMLButtonElement, TabProps>(function TabButton(props, ref) {
  return <MuiTab component="button" ref={ref} {...props} />;
});

const StyledTab = styled(TabButton)(tabRootStyles);

export const Tab = forwardRef<HTMLButtonElement, TabProps>(function Tab(props, ref) {
  return <StyledTab ref={ref} disableRipple disableFocusRipple {...props} />;
});
